import React, { useState } from "react";
import { handleAmazonConnectEmailContact } from "../DynamicBotLoader/ContactCenter/connect";

function First({ contactCenterConfig }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    department: "DMV", // Default
    language: "English" // Default
  });

  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, subject, message, department, language } = formData;

    if (!name || !email || !subject || !message) {
      setError("Please fill out all required fields.");
      return;
    }

    try {
      setIsSubmitting(true);

      const attributes = {
        Department: department,
        Language: language,
        Content: message
      };

      const response = await handleAmazonConnectEmailContact(
        contactCenterConfig,
        name,
        email,
        subject,
        message,
        attributes
      );

      if (response?.ContactId) {
        setSuccessMessage(
          "Thank you for reaching out to us. Someone will respond to you soon using your email."
        );
        setIsCompleted(true);
      } else {
        setError("Failed to send message. Please try again later.");
      }
    } catch (error) {
      setError("An error occurred while sending the message.");
      console.error("Email Contact Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="contact-box">
                <div className="section-tagline">WRITE A MESSAGE</div>
                <h1 className="section-title">Always Here to Help You</h1>
                <p>
                  We value your questions, feedback, and concerns about the services and resources offered by the State of GTS.
                  Whether you need assistance with housing, public safety, employment, or other local government services, 
                  we’re here to ensure your voice is heard and your needs are addressed.
                </p>
              </div>
            </div>

            <div className="col-lg-8">
              {!isCompleted ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row row-gutter-10">
                    <div className="col-12 col-lg-6">
                      <input
                        type="text"
                        className="input-text"
                        placeholder="Your name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        disabled={isSubmitting}
                        aria-required="true"
                      />
                    </div>

                    <div className="col-12 col-lg-6">
                      <input
                        type="email"
                        className="input-text"
                        placeholder="Email address"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={isSubmitting}
                        aria-required="true"
                      />
                    </div>

                    <div className="col-12 col-lg-6">
                      <input
                        type="text"
                        className="input-text"
                        placeholder="Phone number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="col-12 col-lg-6">
                      <input
                        type="text"
                        className="input-text"
                        placeholder="Subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        disabled={isSubmitting}
                        aria-required="true"
                      />
                    </div>

                    <div className="col-12 col-lg-6">
                      <select
                        name="department"
                        value={formData.department}
                        onChange={handleChange}
                        className="input-text"
                        disabled={isSubmitting}
                      >
                        <option value="DMV">DMV</option>
                        <option value="HHS">HHS</option>
                      </select>
                    </div>

                    <div className="col-12 col-lg-6">
                      <select
                        name="language"
                        value={formData.language}
                        onChange={handleChange}
                        className="input-text"
                        disabled={isSubmitting}
                      >
                        <option value="English">English</option>
                        <option value="Spanish">Spanish</option>
                      </select>
                    </div>

                    <div className="col-12 col-lg-12">
                      <textarea
                        name="message"
                        placeholder="Write a message"
                        className="input-text"
                        value={formData.message}
                        onChange={handleChange}
                        disabled={isSubmitting}
                        aria-required="true"
                      />
                    </div>

                    <div className="col-12 col-lg-12">
                      {error && (
                        <p className="error-message" style={{ color: "red" }}>{error}</p>
                      )}
                    </div>

                    <div className="col-12 col-lg-12">
                      <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                        {isSubmitting ? "Sending..." : "Send a Message"}
                      </button>
                    </div>
                  </div>
                </form>
              ) : (
                <div className="success-message-container">
                  <h2>🎉 Message Sent!</h2>
                  <p>{successMessage}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="contact-gmap-section">
        <div className="container">
          <div className="responsive-map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12083.735079362054!2d-74.01702461732008!3d40.785470167558394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c258131938b8d5%3A0xe39c30a8afef2d96!2sWest%20New%20York%2C%20NJ%2007093%2C%20USA!5e0!3m2!1sen!2sin!4v1668832966742!5m2!1sen!2sin"
              width={600}
              height={450}
              title="location"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default First;
